import { Pipe, PipeTransform } from '@angular/core';
import { AppUtils } from '../utils/appUtils';

declare let moment: any;

@Pipe({
  name: 'customHourHHmmFormatterPipe'
})
export class CustomHourHHmmFormatterPipe implements PipeTransform {

  constructor(private appUtils: AppUtils) { }

  transform(value, ...args: any[]): any {
    return this.appUtils.formatHourHHmm(value);
  }

}
